import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Select, Space, Spin, Table, Typography } from 'antd';
import * as adminApi from 'js/utils/adminApi';
import { IEvent } from 'store/slices/types';

const { Title, Text } = Typography;

export default function VotesPage(): ReactElement {
    const [events, setEvents] = useState<IEvent[]>([]);
    const [eventId, setEventId] = useState<number | null>(null);
    const [results, setResults] = useState<adminApi.IVoteResults | null>(null);
    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);

    useEffect(() => {
        adminApi
            .listEvents()
            .then(list => {
                setEvents(list);
                if (list.length) setEventId(list[0].id);
            })
            .finally(() => setLoading(false));
    }, []);

    const load = async (id: number): Promise<void> => {
        setRefreshing(true);
        try {
            const data = await adminApi.getVoteResults(id);
            setResults(data);
        } finally {
            setRefreshing(false);
        }
    };

    useEffect(() => {
        if (eventId === null) return;
        load(eventId).catch(() => {
            /* swallow */
        });
    }, [eventId]);

    if (loading) return <Spin />;

    return (
        <div>
            <Title level={3}>Голосование</Title>
            <Space style={{ marginBottom: 24 }}>
                <span>Event:</span>
                <Select
                    style={{ width: 280 }}
                    value={eventId ?? undefined}
                    onChange={(v): void => setEventId(v)}
                    options={events.map(e => ({ value: e.id, label: e.name }))}
                />
                <Button
                    onClick={(): void => {
                        if (eventId !== null)
                            load(eventId).catch(() => {
                                /* swallow */
                            });
                    }}
                    loading={refreshing}
                >
                    Обновить
                </Button>
            </Space>
            {results && (
                <>
                    <Text style={{ display: 'block', marginBottom: 12 }}>
                        Всего голосов: <b>{results.total}</b>
                    </Text>
                    <Table
                        rowKey="work_id"
                        dataSource={results.results}
                        pagination={false}
                        columns={[
                            {
                                title: '#',
                                render: (_, __, idx): number => idx + 1,
                                width: 60,
                            },
                            {
                                title: 'Работа',
                                dataIndex: 'work_name',
                            },
                            {
                                title: 'Голосов',
                                dataIndex: 'count',
                                width: 120,
                                sorter: (a, b): number => a.count - b.count,
                                defaultSortOrder: 'descend',
                            },
                            {
                                title: '%',
                                width: 100,
                                render: (_, row): string => {
                                    if (!results.total) return '—';
                                    const pct =
                                        (row.count / results.total) * 100;
                                    return `${pct.toFixed(1)}%`;
                                },
                            },
                        ]}
                    />
                </>
            )}
        </div>
    );
}
